import { useAtomValue } from 'jotai';
import { queryClientAtom } from 'jotai-tanstack-query';

import {
    Button,
    HorizontalContainer,
    Modal,
    VerticalContainer,
} from '@/components';

import { R } from '@/caregiverSpace/resources/Texts.resx';

import {
    endConsultationAtom,
    invalidateConsultationDetails,
} from '@/caregiverSpace/entities/consultation';

import { confirmationAtom } from '../model/store';

type ConfirmEndConsultationAfterCallModalProps = {
    consultationUid: string;
    onClose: () => void;
    onCancel: () => void;
    onEnded: (topic?: string | null) => void;
};

export const ConfirmEndConsultationAfterCallModal = ({
    consultationUid,
    onClose,
    onCancel,
    onEnded,
}: ConfirmEndConsultationAfterCallModalProps) => {
    const confirmation = useAtomValue(confirmationAtom);
    const { mutate: endConsultationMutate, isPending } =
        useAtomValue(endConsultationAtom);
    const queryClient = useAtomValue(queryClientAtom);

    const handleConfirm = () => {
        endConsultationMutate(
            { consultationUid },
            {
                onSuccess: () => {
                    invalidateConsultationDetails(queryClient, consultationUid);
                    onEnded(confirmation?.Consultation.Subject);
                },
            },
        );
    };

    return (
        <Modal
            title={R.ConfirmEndConsultationAfterCallTitle}
            onClose={onClose}
            className="max-w-[487px]"
        >
            <VerticalContainer>
                <p>{R.ConsultationWillDisappearFromWaitingRoom}</p>
                <HorizontalContainer className="justify-end">
                    <Button
                        variant="ghost"
                        onClick={onCancel}
                        disabled={isPending}
                    >
                        {R.NoCancel}
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={handleConfirm}
                        disabled={isPending}
                    >
                        {R.YesEndAndWriteNote}
                    </Button>
                </HorizontalContainer>
            </VerticalContainer>
        </Modal>
    );
};
